<template>
  <div>
    <div class="d-flex" v-if="!createMode">
      <div class="mr-auto" v-if="node.meta.question">
        {{ node.meta.question }}
      </div>
      <div class="mr-auto" v-if="!editMode">
        {{ node.value }}
      </div>
      <div class="mr-auto" v-if="node.meta.comment">
        {{ node.meta.comment }}
      </div>
      <div class="mr-auto font-weight-light text-caption">
        {{ showAuthor() }}
      </div>
      <span v-if="editMode">
        <GlossaryTextField
          v-model="node.value"
          :label="node.name"
          v-on:updatetext="textUpdate($event)"
        ></GlossaryTextField>
      </span>
    </div>

    <div v-if="createMode">
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Question (optional)"
              v-model="node.meta.question"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Comment (optional)"
              v-model="node.meta.comment"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Tooltip (optional)"
              v-model="node.meta.tooltip"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row> -->
    </div>
  </div>
</template>

<script>
import GlossaryTextField from "../../../utils/components/textFieldWithGlossary";
import { mapGetters } from "vuex";

export default {
  components: { GlossaryTextField },
  name: "npTextInput",
  props: {
    node: Object,
    editMode: Boolean,

    createMode: { type: Boolean, default: false, required: false },
    selectedRecord: Object,
    isRoot: Boolean,
  },
  mounted() {
    this.$emit("validation", true);
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      loginDetails: "getUser",
      getName: "getLoggedInName",
    }),
  },
  methods: {
    textUpdate($event) {
      this.changeValue($event, this.node);
    },
    changeValue(e) {
      if (!e) {
        return;
      }
      this.node.value = e;
      this.node.authorName = this.getName;
      this.node.authorId = this.loginDetails.id;

      this.$root.$emit("edit:update");
    },
    showAuthor() {
      if (this.node.authorName) {
        return ` Last changed by ${this.node.authorName}`;
      }
      return "";
    },
  },
};
</script>

<style></style>
